<div class="tdb-condition">
  <select
    class="tdb-select tdb-select--subj"
    [class.tdb-select--active]="!!subj()"
    [attr.data-testid]="'tdb-subj-' + scopeId()"
    [attr.aria-label]="'tdb.subj.ariaLabel' | translate: { id: scopeId() }"
    [disabled]="disabled()"
    [value]="subj()"
    (change)="onSubjChange($event)"
  >
    <option value="" [selected]="!subj()">{{ 'tdb.subj.none' | translate }}</option>
    @for (s of subjects; track s.value) {
      <option [value]="s.value" [selected]="s.value === subj()">{{ s.labelKey | translate }}</option>
    }
  </select>

  @if (subj()) {
    <input
      type="text"
      class="tdb-input tdb-input--ref"
      [class.tdb-input--active]="!!(override().ref || '').trim()"
      [class.tdb-input--missing]="missing().includes('ref')"
      [attr.aria-invalid]="missing().includes('ref') ? 'true' : null"
      [attr.data-testid]="'tdb-ref-' + scopeId()"
      [attr.aria-label]="'tdb.ref.ariaLabel' | translate: { id: scopeId() }"
      [disabled]="disabled()"
      [value]="override().ref || ''"
      [placeholder]="refPlaceholderKey() | translate"
      (input)="onRefInput($event)"
    />
    <select
      class="tdb-select tdb-select--op"
      [class.tdb-select--active]="!!opCode()"
      [class.tdb-select--missing]="missing().includes('op')"
      [attr.aria-invalid]="missing().includes('op') ? 'true' : null"
      [attr.data-testid]="'tdb-op-' + scopeId()"
      [attr.aria-label]="'tdb.op.ariaLabel' | translate: { id: scopeId() }"
      [disabled]="disabled()"
      [value]="opCode()"
      (change)="onOpChange($event)"
    >
      <option value="" [selected]="!opCode()">{{ 'tdb.op.placeholder' | translate }}</option>
      @for (op of operators(); track op.code) {
        <option [value]="op.code" [selected]="op.code === opCode()">{{ op.labelKey | translate }}</option>
      }
    </select>
    @if (needsValue()) {
      <input
        type="text"
        class="tdb-input tdb-input--val"
        [class.tdb-input--active]="!!(override().val || '').trim()"
        [class.tdb-input--missing]="missing().includes('val')"
        [attr.aria-invalid]="missing().includes('val') ? 'true' : null"
        [attr.data-testid]="'tdb-val-' + scopeId()"
        [attr.aria-label]="'tdb.val.ariaLabel' | translate: { id: scopeId() }"
        [disabled]="disabled()"
        [value]="override().val || ''"
        [placeholder]="'tdb.val.placeholder' | translate"
        (input)="onValInput($event)"
      />
    }
  }
</div>
@if (missing().length) {
  <p class="tdb-condition-hint" role="status" [attr.data-testid]="'tdb-condition-missing-' + scopeId()">
    {{ 'tdb.condition.missing' | translate: { fields: missingFieldsText() } }}
  </p>
}
